// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2F9WW","inner":"styles_inner__1z6qK","right":"styles_right__aP_Tk","close":"styles_close__2sWt_","footer":"styles_footer__2S0Ee"};